import { split } from 'ramda';
import { Source } from '../../constants/Source';

type TParsePath = (path: string) => { source: Source; folderId: string };
export const parsePath: TParsePath = (path) => {
  const [source, folderId] = split('/', path);

  return {
    source: source as Source,
    folderId,
  };
};
